<template>
  <div class="personal-role-wrapper" ref="wrapperRef">
    <div class="personal-info" ref="contentRef">
      <HDFHeader03 />

    <!-- <UserVipList 
    :title="null" 
    :width="'1400px'"
    :tableData="userState.userInfo.value.userPricePackageInfoList"
    /> -->

    <!-- <MembershipCard
      style="width: 1400px; margin-top: 50px;"
      @tab-change="handleTabChange"
      @membership-select="handleMembershipSelect"
      @purchase="handlePurchase"
      :vipCode="vipCode"
    /> -->

    <!-- <ThreeProduct/> -->
    <!-- <div class="member-container">
      <Member365/>
    </div> -->
    <!-- <PersonalRoleList /> -->
    <PersonalInfoCard />

    <!-- <main v-if="buyType === 'def'">
      <ThreeProduct/>
      <div class="member-container">
        <Member365/>
      </div>
      <PersonalRoleList />
      <PersonalInfoCard />
    </main> -->

    <!-- <main v-if="buyType === 'one'">
      <PersonalTable :title="null" :width="'1296px'"/>
      <div class="upgrader-member-container">
        <UpgradeMember />
      </div>
      <div class="member-container">
        <Member365 :buyClick="buyVip"/>
      </div>
      <PersonalRoleList />
      <PersonalInfoCard />
    </main>

    <main v-if="buyType === 'all'">
      <PersonalTable :title="null" :width="'1296px'"/>
      <PersonalRoleList />
      <PersonalInfoCard />
    </main> -->

    <div class="footer-box">
      <HDFFooter03 />
    </div>
    </div>
  </div>

  <!-- 支付弹窗组件 -->
  <PaymentModal ref="paymentModelRef" />
  
  <PaymentDialog ref="paymentDialog" />

</template>
<script setup>
//基础配置
import { ref, onMounted, onBeforeUnmount } from 'vue'
import Router from '@/router/index'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { storeToRefs } from 'pinia'

//组件
import HDFHeader03 from '@/components/HDFHeader03.vue'
import HDFFooter03 from '@/components/HDFFooter03.vue'
import PersonalRoleList from '@/components/PersonalRoleList.vue'
import UserVipList from '@/components/UserVipList.vue'
import PersonalInfoCard from '@/components/PersonalInfoCard.vue'
import ThreeProduct from '@/components/ThreeProduct.vue'
import Member365 from '@/components/HDFMember365.vue'
import UpgradeMember from '@/components/UpgradeMember.vue'
import PaymentModal from '@/components/PaymentModal.vue'
import MembershipCard from '@/components/MembershipCard.vue'
import PaymentDialog from '@/components/PayMentDialog.vue';

// ===================== 等比例缩放逻辑 =====================
const wrapperRef = ref(null)
const contentRef = ref(null)
const MAX_WIDTH = 1920 // 界面最大宽度
const SCALE_WIDTH = 1920 // 缩放基准宽度

const updateScale = () => {
  if (!wrapperRef.value || !contentRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1920px时进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    
    // 设置容器高度为缩放后的实际高度
    const contentHeight = contentRef.value.scrollHeight
    wrapperRef.value.style.height = `${contentHeight * scale}px`
    
    // 应用缩放
    contentRef.value.style.transform = `scale(${scale})`
    contentRef.value.style.transformOrigin = 'top left'
    contentRef.value.style.margin = '0'
  } else {
    // 大于等于1920px时保持原始大小并居中
    wrapperRef.value.style.height = 'auto'
    contentRef.value.style.transform = 'none'
    contentRef.value.style.margin = '0 auto'
  }
}

//接口
import { GetUserInfo } from '@/api/api.js'
import { createOrder } from '@/api/order'
import { getWxPayInfo, getAliPayInfo } from '@/api/pay'
import { membersshipJson } from '@/api/temp/data'
import { apiGetPlatformVipList } from '@/api/vip'

//工具
import { saveUserInfo, getUserVipLevel } from '@/utils/common'
import { setWxPayInfo, saveAlipayFormHtml } from '@/utils/common'
import { getUrlParam } from '@/utils/common'

//数据管理
import { useVipStore, useUserStore } from '@/stores'

const paymentModelRef = ref(null)
const vipCode = ref('')

// vipCode.value = '23219974a9f970b8f9e2df74f9f83b29'
const setVipCode = () => {
   const v = getUrlParam('vipCode');
   if(v){
    vipCode.value = v;
   }
}

const vipStore = useVipStore()
const vipState = storeToRefs(vipStore)
const userStore = useUserStore()
const userState = storeToRefs(userStore)

const router = useRouter()
const paymentDialog = ref(null);
const buyType = ref('')

// 购买处理
const handlePurchase = (data) => {
  const { membership, tab } = data
  console.log(membership)

  createOrderInfo({pricePackageCode: membership.code}, (orderInfo) => {
    console.log(`购买${membership.name}，价格：¥${orderInfo.price}`, 'warning')
    console.log(orderInfo)
    paymentModelRef.value.showDialog(
      '选择支付方式',
      orderInfo.orderNo,
      membership.price,
      membership.groupName + '-' + membership.title,
    );
  })
}


const createOrderInfo = (data, callback) => {
  //创建购买订单
  //20250330111183747383：智码平台编号，all: 联合会员编号
  createOrder(data).then(response => {
    const orderRes = response.data;
    if(orderRes.code === 200){
      const orderInfo = orderRes.data;
      if(callback){
        callback(orderInfo)
      }
    }else{
      ElMessage({
        message: orderRes.msg,
        type: 'warning'
      })
    }

  })
}

const buyVip = (packageCode, paymentType) => {
  showModal.value = true
  if(packageCode){
    if (paymentType === 'wechat') {
      console.log('用户选择了微信支付');
      // 在这里处理微信支付逻辑
      createOrderInfo({pricePackageCode: packageCode, channel: paymentType}, (orderInfo) => {
        // TODO 目前默认使用微信，后续添加弹窗选择，先跑通流程
        //使用订单信息向后端申请微信支付信息用于扫码支付
        getWxPayInfo({orderNo: orderInfo.orderNo}).then( wxResponse => {
          const wxRes = wxResponse.data;
          if(wxRes.code === 200){

            //缓存微信支付信息给支付页面进行扫码使用
            const wxPayInfo = wxRes.data;
            setWxPayInfo(wxPayInfo)
            router.push('/wxPay')

          }else{
            ElMessage({
              message: wxRes.msg,
              type: 'warning'
            })
          }
        })
      });

    } else if (paymentType === 'alipay') {

      console.log('用户选择了支付宝支付');
      // 在这里处理支付宝支付逻辑
      createOrderInfo({pricePackageCode: packageCode, channel: paymentType}, (orderInfo) => {
        getAliPayInfo({orderNo: orderInfo.orderNo}).then(response => {
          const res = response.data;
          if(res.code === 200){
            const payFormHtml = res.data;
            saveAlipayFormHtml(payFormHtml)
            //跳转到支付宝Form Html内容的承载页
            window.location.href='/alipay'
          }else{
            ElMessage({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      });

    }
    return;
  }
  //创建购买订单
  //20250330111183747383：智码平台编号，all: 联合会员编号
  // createOrder({platformCode: platformCode}).then(response => {
  //   const orderRes = response.data;
  //   if(orderRes.code === 200){
  //     const orderInfo = orderRes.data;
  //     // TODO 目前默认使用微信，后续添加弹窗选择，先跑通流程
  //     //使用订单信息向后端申请微信支付信息用于扫码支付
  //     getWxPayInfo({orderNo: orderInfo.orderNo}).then( wxResponse => {
  //       const wxRes = wxResponse.data;
  //       if(wxRes.code === 200){
  //         //缓存微信支付信息给支付页面进行扫码使用
  //         const wxPayInfo = wxRes.data;
  //         setWxPayInfo(wxPayInfo)
  //         router.push('/pay')

  //       }else{
  //         ElMessage({
  //           message: wxRes.msg,
  //           type: 'warning'
  //         })
  //       }
  //     })
  //   }else{
  //     ElMessage({
  //       message: orderRes.msg,
  //       type: 'warning'
  //     })
  //   }
  // })
}

onMounted(() => {
  // 打开页面每次都查询一次用户信息，以获取用户最新状态
  GetUserInfo().then(response => {
    const res = response.data;
    if(res.code === 200){
      const userInfo = res.data;
      saveUserInfo(userInfo)
      // if(!userInfo.name){
      //   Router.push('/personalInfo')
      // }
      
      // buyType.value = getUserVipLevel()
      console.log('用户：', userInfo)
      userStore.setUserInfo(userInfo)
    }
  })

  apiGetPlatformVipList().then(response => { 
    const res = response.data;
    if(res.code === 200){
      const platformVipList = res.data;
      vipStore.setVipList(platformVipList)
    }
  })

  setVipCode();

  // 初始化缩放
  updateScale()
  window.addEventListener('resize', updateScale)

})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScale)
})
</script>

<style scoped>
.personal-role-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.personal-info {
  width: 1920px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform-origin: top left;
}
main {
  /* background: url('@/assets/images/bg/bg-personalcenter.png') no-repeat; */
  background-size: 100% auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 100px 0;
}
.upgrader-member-container {
  padding: 60px 0;
}
.member-container {
  position: relative;
  width: 100%;
  height: 300px;
}
.footer-box {
  width: 100%;
}
</style>
